module.exports = __webpack_public_path__ + "img/qr-app.e3ba8be3.svg";